var $744ca7c0f59356d5$exports = {};
$744ca7c0f59356d5$exports = {
    "invalidSelection": (args, formatter)=>`Izbrano ${formatter.plural(args.selectedCount, {
            one: `date`,
            other: `dates`
        })} ni na voljo.`
};


export {$744ca7c0f59356d5$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
